module.exports = __webpack_public_path__ + "static/media/giphy.02e9f762.gif";